// @ts-nocheck
import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
// TODO: Migrate module so that you don’t import from the corp project in a global module
/* eslint-disable restrict-imports/restrict-imports */
import Table from 'corp/components/UI/Table';
import Select from 'corp/components/UI/Select';
import { RegularExpressionFilter } from 'corp/lib/tableFilters';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { InputCheckbox, InputText, Button } from 'design-system/Form';
import { PermissionGroupNameDupes } from 'react-scale/corp/components/QMWorkflow/QMWorkflowSidebar';

const PermissionsTable = props => {
  const alreadyGrantedPermissionGroups = props.data
    .filter(item => item.job && item.job.permissionGroup)
    .map(item => item.job.permissionGroup.name);
  const renderCell = (cellInfo, editableRenderer, customValue) => {
    const readOnly = cellInfo.column.readOnly && cellInfo.column.readOnly(cellInfo);
    return (cellInfo.original.type === 'saved' && !cellInfo.original.editable) || readOnly
      ? (customValue && customValue(cellInfo.original, cellInfo.value)) || cellInfo.value
      : editableRenderer(cellInfo);
  };

  const findCustomer = async text => {
    try {
      if (text) {
        const { users } = await apiFetch(null, `corp-api/find/customers`, {
          query: { search: text },
        });
        return { options: users };
      }
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
    }
    return { options: [] };
  };

  const findTaskTypes = text => {
    return props.taskTypes.filter(taskType => taskType.value.match(text));
  };

  const findGroup = async (text, permission) => {
    try {
      const groups = (
        await apiFetch(
          null,
          `internal/permissions/groups?name_prefix=${text}&task_type=${
            permission.taskType || ''
          }&task_customer_id=${permission.taskCustomer?.id || ''}&limit=100`,
        )
      ).filter(group => !_.includes(alreadyGrantedPermissionGroups, group.name));

      return { options: groups };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return { options: [] };
    }
  };

  const renderEditableSelect = (dataSource, options) => {
    const renderer = cellInfo => {
      const selected = options.selectedValue
        ? options.selectedValue(cellInfo.value)
        : cellInfo.value;
      const commonProps = {
        multi: false,
        cache: null,
        value: selected,
        className: options.required && !selected ? 'invalid' : '',
        selectedValue: selected,
        valueKey: options.value,
        labelKey: options.label,
        onChange: value => {
          props.updatePermission(
            cellInfo.index,
            options.path || cellInfo.column.id,
            options.save ? value[options.save] : value,
          );
        },
      };
      return options.async ? (
        <Select
          {...commonProps}
          autoload={(options.autoload === undefined && true) || options.autoload}
          loadOptions={text => dataSource(text, cellInfo.original.job)}
        />
      ) : (
        <Select {...commonProps} options={dataSource('', cellInfo.original.job)} />
      );
    };
    return renderer.bind(this);
  };

  const renderNumberInput = inputProps => {
    const renderer = cellInfo => {
      // HACK: the width of a number input is adjusted
      // automatically by the browser when it has the min and max
      // attributes—i think it's because it knows how many digits
      // will be displayed. With the style declaration below we
      // override the width of <InputText> which ends up being
      // less than 100%.
      return (
        <InputText
          type="number"
          style={{ minWidth: '100%' }}
          {...inputProps}
          value={cellInfo.value}
          onChange={event => {
            const value = event.target.value;
            props.updatePermission(cellInfo.index, cellInfo.column.id, value);
          }}
        />
      );
    };
    return renderer.bind(this);
  };

  const CheckboxCell = ({ index, value, original, column }) => {
    return (
      <InputCheckbox
        checked={value}
        disabled={
          original.type === 'saved' && (original.editable === undefined || !original.editable)
        }
        onClick={() => props.updatePermission(index, column.id, !value)}
        type="checkbox"
        name="empty"
      />
    );
  };

  const ActionsCell = ({ original, index }) => {
    const actions = [];
    if (!original.job.disabled) {
      actions.push([
        original.remove ? (
          <Button key="cancelRemove" onClick={() => props.cancelRemove(index)}>
            Cancel Disable
          </Button>
        ) : (
          !original.editable && (
            <Button
              key="remove"
              onClick={() =>
                original.type === 'new' ? props.removeNew(index) : props.removePermission(index)
              }
            >
              {original.type === 'new' ? 'Remove' : 'Disable'}
            </Button>
          )
        ),
      ]);
    } else if (original.job.disabled) {
      actions.push([
        original.enable ? (
          <Button key="cancelEnable" onClick={() => props.cancelEnable(index)}>
            Cancel Enable
          </Button>
        ) : (
          <Button key="enable" onClick={() => props.enablePermission(index)}>
            Enable
          </Button>
        ),
      ]);
    }
    if (props.loggedUserIsAdmin || !original.job.disabled) {
      actions.push(
        original.type !== 'new' &&
          (original.editable ? (
            <Button key="cancelEdit" onClick={() => props.cancelEditPermission(index)}>
              Cancel Edit
            </Button>
          ) : (
            !original.remove && (
              <Button key="edit" onClick={() => props.editPermission(index)}>
                Edit
              </Button>
            )
          )),
      );
    }
    return actions;
  };

  const columns = [
    {
      Header: 'Enabled',
      accessor: 'job.disabled',
      midWidth: 10,
      Cell: cellInfo => (cellInfo.original.job.disabled ? 'NO' : 'yes'),
    },
    {
      Header: 'Task Type',
      accessor: 'job.taskType',
      minWidth: 150,
      filterable: true,
      Cell: cellInfo =>
        cellInfo.original.job.permissionGroup || !props.loggedUserIsAdmin
          ? (cellInfo.original.job.permissionGroup &&
              cellInfo.original.job.permissionGroup.taskType) ||
            cellInfo.original.job.taskType
          : renderCell(
              cellInfo,
              renderEditableSelect(findTaskTypes, {
                label: 'label',
                value: 'value',
                save: 'value',
                required: true,
              }),
            ),
      readOnly: ({ original }) => original.type !== 'new' || original.permissionGroup,
    },
    {
      Header: 'Customer Email',
      show: props.loggedUserIsAdmin,
      accessor: 'job.taskCustomer.email',
      width: 280,
      filterable: true,
      Cell: cellInfo =>
        cellInfo.original.job.permissionGroup
          ? cellInfo.original.job.permissionGroup.taskCustomer.email ||
            cellInfo.original.job.taskCustomer.email
          : renderCell(
              cellInfo,
              renderEditableSelect(findCustomer, {
                label: 'email',
                value: 'email',
                path: 'job.taskCustomer',
                async: true,
                selectedValue: value => ({ email: value }),
              }),
              (original, value) => value || '(all)',
            ),
      readOnly: ({ original }) => original.type !== 'new' || original.permissionGroup,
    },
    {
      Header: 'Attempter',
      accessor: 'job.canAttempt',
      filterable: true,
      Cell: CheckboxCell,
      maxWidth: 80,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'Reviewer',
      accessor: 'job.canReview',
      filterable: true,
      Cell: CheckboxCell,
      maxWidth: 80,
      style: {
        textAlign: 'center',
      },
    },
    {
      id: 'job.taskCustomer.id',
      Header: 'Customer Id',
      accessor: cell =>
        (cell.job.taskCustomer && cell.job.taskCustomer.id) ||
        (cell.job.permissionGroup &&
          (cell.job.permissionGroup.taskCustomer._id || cell.job.permissionGroup.taskCustomer)) ||
        '(all)',
      filterable: true,
      minWidth: 180,
    },
    {
      Header: 'Review Level',
      accessor: 'job.reviewLevel',
      filterable: true,
      Cell: cellInfo => renderCell(cellInfo, renderNumberInput({ min: '0', max: '12' })),
      minWidth: 80,
    },
    {
      Header: 'Review Sample Rate',
      show: props.loggedUserIsAdmin,
      accessor: 'job.corpReviewSampleRate',
      filterable: true,
      Cell: cellInfo =>
        renderCell(cellInfo, renderNumberInput({ min: '0', max: '1', step: '0.01' })),
      minWidth: 80,
    },
    {
      Header: 'Permission Group',
      accessor: 'job.permissionGroup.name',
      filterable: true,
      Cell: cellInfo => {
        const permissionGroupCell = (
          <>
            <PermissionGroupNameDupes name={cellInfo.value} searchButton={true} />
            {renderCell(
              cellInfo,
              renderEditableSelect(findGroup, {
                label: 'name',
                value: 'name',
                autoload: false,
                path: 'job.permissionGroup',
                async: true,
                selectedValue: value => ({ name: value }),
              }),
            )}
          </>
        );
        return permissionGroupCell;
      },
      readOnly: ({ original }) => original.type !== 'new',
      minWidth: 180,
    },
    {
      Header: 'Last Use',
      show: !props.loggedUserIsAdmin,
      accessor: 'job.lastActive',
      Cell: ({ value }) => moment.utc(value).format('MMM Do YY, h:mm:ss a'),
      minWidth: 130,
    },
    {
      Header: 'Actions',
      sortable: false,
      Cell: ActionsCell,
      minWidth: 150,
    },
  ];

  return (
    <div>
      <Table
        id={`${props.scalerId}PermissionTable`}
        loading={props.loading}
        data={props.data}
        resolveData={data => data.map(row => row)}
        columns={columns}
        pageSize={props.pageSize}
        className="-striped -highlight"
        page={props.page}
        onPageChange={props.onPageChange}
        onPageSizeChange={props.onPageSizeChange}
        defaultFilterMethod={RegularExpressionFilter}
        onFilteredChange={() => props.onPageChange(0)}
        getTrProps={(state, rowInfo, column) => {
          const classNames = [];
          if (rowInfo && rowInfo.original.type === 'new') {
            classNames.push('new-job');
          }
          if (rowInfo && rowInfo.original.remove) {
            classNames.push('to-remove');
          }
          if (rowInfo && rowInfo.original.job.disabled) {
            classNames.push('disabled');
          }
          if (rowInfo && rowInfo.original.enable) {
            classNames.push('to-enable');
          }
          if (rowInfo && rowInfo.original.editable) {
            classNames.push('editable');
          }
          return Object.assign(
            {
              className: classNames.join(' '),
            },
            (props.getTrProps && props.getTrProps(state, rowInfo, column)) || {},
          );
        }}
      />

      <style jsx global>{`
        .ReactTable {
          width: auto;
          height: auto;
        }

        .Select {
          width: 100%;
        }

        .rt-tr.new-job .rt-td,
        .rt-tr.editable .rt-td {
          overflow: visible;
        }

        .rt-tr.new-job,
        .rt-tr.new-job:hover {
          background-color: #f0ffe9 !important;
        }

        .rt-tr.to-remove,
        .rt-tr.to-remove:hover {
          background-color: #ffb9b4 !important;
        }

        .rt-tr.editable,
        .rt-tr.editable:hover {
          background-color: #feffd7 !important;
        }

        .rt-tr.disabled,
        .rt-tr.disabled:hover {
          background-color: #ffbb99 !important;
        }

        .rt-tr.to-enable,
        .rt-tr.to-enable:hover {
          background-color: #ccffff !important;
        }

        .invalid .Select-control {
          border-color: red;
        }
      `}</style>
    </div>
  );
};

PermissionsTable.propTypes = {
  scalerId: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  data: PropTypes.array.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  getTrProps: PropTypes.func,
  taskTypes: PropTypes.array.isRequired,
  groups: PropTypes.array,
  updatePermission: PropTypes.func.isRequired,
  removeNew: PropTypes.func.isRequired,
  cancelRemove: PropTypes.func.isRequired,
  removePermission: PropTypes.func.isRequired,
  editPermission: PropTypes.func.isRequired,
  cancelEditPermission: PropTypes.func.isRequired,
};

export default PermissionsTable;
